export const Separator = ({ className }) => (
  <div className={`separator ${className}`} />
);
